/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {IWinRatioConfig} from "../core/config/WinRatio";
import {BetWinMode} from "../core/config/BetWinMode";

export class DevilsCrossRoadGameConfig {

    // Game basic
    public static BET_WIN_MODE:BetWinMode = BetWinMode.BET_WAY;

    // Win
    public static WIN_RATIOS:IWinRatioConfig[] = [
        {
            ratio : 0,
            name : "Tiny Win",
            duration : 0,
            winLevel : 0,
            bigWinLevel : -1
        },
        {
            ratio : 1,
            startRatioExcluded : true,
            name : "Small Win",
            duration : 0,
            winLevel : 1,
            bigWinLevel : -1
        },
        {
            ratio : 3,
            name : "Medium Win",
            duration : 0.4,
            winLevel : 2,
            bigWinLevel : -1
        },
        {
            ratio : 5,
            name : "Large Win",
            duration : 0.8,
            winLevel : 3,
            bigWinLevel : -1
        },
        {
            ratio : 15,
            name : "Big Win 1",
            duration : 5.310,
            winLevel : 3,
            bigWinLevel : 0
        },
        {
            ratio : 25,
            name : "Big Win 2",
            duration : 5.310,
            winLevel : 3,
            bigWinLevel : 1

        },
        {
            ratio : 50,
            name : "Big Win 3",
            duration : 5.310,
            winLevel : 3,
            bigWinLevel : 2
        },
        {
            ratio : 100,
            name : "Big Win 4",
            duration : 5.310,
            winLevel : 3,
            bigWinLevel : 3
        },
        {
            ratio : 500,
            name : "Big Win 5",
            duration : 5.310,
            winLevel : 3,
            bigWinLevel : 4
        }
    ];

    // FS
    public static POSSIBLE_STICKY_SYMBOLS:string [] = [
        "C", "CX"
    ];

    public static FS_SYMBOL_WIDTH:number = 100;
    public static FS_SYMBOL_HEIGHT:number = 100;

    public static freespinStepSize:{ x:number, y:number } = {
        x : 0,
        y : DevilsCrossRoadGameConfig.FS_SYMBOL_HEIGHT * 1,
    }

    static FS_TMP_DEFAULT_REEL_SET:string [] = [
        "X", "C", "X", "X", "C", "C", "X", "X", "C", "X", "X", "X", "C", "C", "X", "X", "C", "X", "C", "X", "X", "C", "C", "X", "X", "C", "X", "X", "X", "X",
        "C", "C", "X", "X", "X", "CX", "X", "C", "X", "X", "C", "X", "X", "C", "C", "X", "X", "X", "C", "X", "C", "C", "X", "X", "C", "X", "C", "C", "X", "C", "C",
        "X", "X", "C", "X", "X", "C", "X", "X", "C", "C","C", "C", "X", "X", "C", "X", "X", "X"
    ];

    public static FS_TMP_FEATURE_REEL_SET:string [] = [
        "F", "X", "F", "F", "X", "X", "F", "X", "X", "F", "F", "X", "X", "F", "X", "X", "X", "F", "F", "X", "X", "F", "X", "X", "F", "X", "X", "F", "F", "X", "X",
        "F", "X", "X", "X", "X", "X", "F", "X", "X", "F", "F", "X", "X", "F", "X", "X", "X", "F", "F", "X", "X", "F", "X", "X", "F", "X", "F", "F", "X", "X", "F"
    ];

    public static FS_FEATURE_RIDS:number [] = [0, 6, 12, 18, 24, 31, 32, 33, 34, 35, 36];

    public static FS_SYMBOL_DROP_DELAY = 0.1;
    public static FS_SYMBOL_DROP_FAST_SPIN_DELAY = 0.05;
    public static FS_PLAYED_REEL_LAND_SOUND: boolean[] = [false, false, false, false, false];
}